import { useTranslation } from "react-i18next";
import { Container, Col, Row } from "react-bootstrap";
import { handleLogin } from "../MyNav/LoginButton";
const LoginExpiration = () => {
    const { t } = useTranslation(["common", "errors"]);
    return (
        <Container className="mt-10">
            <Row className="justify-content-center align-items-center">
                <Col xs="auto">
                    <h1>
                        <i className="bi bi-exclamation-triangle-fill text-warning me-3"></i>
                        {t("errors:login_session_expired")}
                    </h1>
                </Col>
            </Row>
            <Row className="justify-content-center align-items-center mt-3">
                <Col xs="auto" md={8}>
                    <h3 className="text-center">
                        {t("common:please")}{" "}
                        <a
                            style={{ cursor: "pointer" }}
                            onClick={handleLogin}
                            className="link-offset-1-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
                        >
                            {t("common:login")}
                        </a>{" "}
                        {t("common:again_period")}
                    </h3>
                </Col>
            </Row>
        </Container>
    );
};

export default LoginExpiration;
